<template>
  <div>
    <v-row>
      <v-col cols="12" class="pa-0">
        <v-tooltip v-if="isGlobalAdmin" top>
          <template v-slot:activator="{ on }">
            <v-btn
              :disabled="
                parkingFine.status !== 'PAID' &&
                parkingFine.status !== 'VOID' &&
                parkingFine.status !== 'WARNING'
                  ? false
                  : true
              "
              icon
              color="success"
              @click="openMarkFineAsPaidDialog(parkingFine)"
              v-on="on"
            >
              <v-icon small>mdi-check</v-icon>
            </v-btn>
          </template>
          <span>
            {{ $vuetify.lang.t('$vuetify.ENFORCEMENT.MARK_AS_PAID') }}
          </span>
        </v-tooltip>
        <v-tooltip v-if="isGlobalAdmin" top>
          <template v-slot:activator="{ on }">
            <v-btn
              :disabled="
                parkingFine.status !== 'PAID' &&
                parkingFine.status !== 'VOID' &&
                parkingFine.status !== 'WARNING'
                  ? false
                  : true
              "
              icon
              color="error"
              @click="openCancelFineDialog(parkingFine)"
              v-on="on"
            >
              <v-icon small>mdi-cancel</v-icon>
            </v-btn>
          </template>
          <span>
            {{ $vuetify.lang.t('$vuetify.ENFORCEMENT.CANCEL_FINE') }}
          </span>
        </v-tooltip>
        <v-tooltip top>
          <template v-slot:activator="{ on }">
            <v-btn
              icon
              :class="
                parkingFine.images && parkingFine.images.length
                  ? 'primary--text'
                  : 'error--text'
              "
              @click.stop="openImageDialog(parkingFine)"
              v-on="on"
            >
              <v-icon small>mdi-image</v-icon>
            </v-btn>
          </template>
          <span>
            {{ $vuetify.lang.t('$vuetify.ENFORCEMENT.LOOK_IMAGES') }}
          </span>
        </v-tooltip>
        <v-tooltip v-if="isGlobalAdmin" top>
          <template v-slot:activator="{ on }">
            <v-btn
              :disabled="
                parkingFine.status === 'PAID' ||
                parkingFine.status === 'VOID' ||
                parkingFine.status === 'WARNING'
                  ? true
                  : false
              "
              icon
              @click="openEditParkingFineDialog(parkingFine)"
              v-on="on"
            >
              <v-icon small>mdi-pencil</v-icon>
            </v-btn>
          </template>
          <span>
            {{ $vuetify.lang.t('$vuetify.EDIT') }}
          </span>
        </v-tooltip>

        <v-tooltip v-if="isGlobalAdmin" top>
          <template v-slot:activator="{ on }">
            <v-btn icon @click.stop="resetFine()" v-on="on">
              <v-icon small>mdi-restore</v-icon>
            </v-btn>
          </template>
          <span>
            {{ $vuetify.lang.t('$vuetify.ENFORCEMENT.RESET_PARKING_FINE') }}
          </span>
        </v-tooltip>

        <v-tooltip v-if="isGlobalAdmin" top>
          <template v-slot:activator="{ on }">
            <v-btn
              icon
              color="error"
              :disabled="parkingFine.debtsSent"
              @click.stop="sendToJulianus()"
              v-on="on"
            >
              <v-icon small>mdi-forward</v-icon>
            </v-btn>
          </template>
          <span>
            {{ $vuetify.lang.t('$vuetify.ENFORCEMENT.SEND_FINE_TO_JULIANUS') }}
          </span>
        </v-tooltip>

        <v-tooltip v-if="isGlobalAdmin" top>
          <template v-slot:activator="{ on }">
            <v-btn
              icon
              color="success"
              @click.stop="openDebtIncomeDialog()"
              v-on="on"
            >
              <v-icon small>mdi-cash</v-icon>
            </v-btn>
          </template>
          <span>
            {{ $vuetify.lang.t('$vuetify.ENFORCEMENT.DEBT_INCOMES') }}
          </span>
        </v-tooltip>

        <v-menu
          v-if="!parkingFine.doNotForwardDebts"
          v-model="forwardDebtsAtPicker"
          :close-on-content-click="false"
          :nudge-right="40"
          transition="scale-transition"
          offset-y
          min-width="290px"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-btn icon color="black" v-bind="attrs" v-on="on">
              <v-tooltip v-if="isGlobalAdmin" top>
                <template v-slot:activator="{ on }">
                  <v-icon small v-on="on">mdi-calendar</v-icon>
                </template>
                <span>
                  {{ $vuetify.lang.t('$vuetify.ENFORCEMENT.FORWARD_DEBTS_AT') }}
                </span>
              </v-tooltip>
            </v-btn>
          </template>
          <v-date-picker
            :value="
              formatDateISO(getDateInTimeZone(forwardDebtsAt, 'Europe/Tallinn'))
            "
            @change="
              forwardDebtsAt = getDateWithTimeZone($event, 'Europe/Tallinn')
              updateForwardDebtsAtValue()
            "
            @input="forwardDebtsAtPicker = false"
          ></v-date-picker>
        </v-menu>

        <v-tooltip v-if="isGlobalAdmin" top>
          <template v-slot:activator="{ on }">
            <v-icon
              :style="
                parkingFine.comments
                  ? 'visibility: visible;'
                  : 'visibility: hidden;'
              "
              small
              v-on="on"
              >mdi-help</v-icon
            >
          </template>
          <span>
            {{ parkingFine.comments }}
          </span>
        </v-tooltip>
      </v-col>
      <v-col cols="12" class="ma-0 py-0 d-flex align-items-center">
        <a
          :href="
            `https://trahv.snabb.xyz/vehicles/${parkingFine.vehicleNumber}/parking-fines/${parkingFine.referenceNumber}`
          "
          target="_blank"
        >
          {{
            `https://trahv.snabb.xyz/vehicles/${parkingFine.vehicleNumber}/parking-fines/${parkingFine.referenceNumber}`
          }}
        </a>
        <v-icon
          class="ml-3"
          @click="
            copyToClipboard(
              `https://trahv.snabb.xyz/vehicles/${parkingFine.vehicleNumber}/parking-fines/${parkingFine.referenceNumber}`
            )
          "
        >
          mdi-clipboard
        </v-icon>
      </v-col>
      <v-col cols="12" class="d-flex justify-end">
        <v-switch
          v-model="doNotForwardDebts"
          :label="$vuetify.lang.t(`$vuetify.ENFORCEMENT.DO_NOT_FORWARD_DEBTS`)"
          :loading="
            loading.state && loading.type === 'putDoNotForwardDebtsValue'
          "
          @change="onDoNotForwardDebtsChange"
        >
        </v-switch>
      </v-col>
    </v-row>
    <v-row v-if="parkingFine && parkingFine.place">
      <v-col sm="4" class="text--primary">
        <div class="d-flex justify-space-between">
          <span class="font-weight-bold">ID</span>
          <span>{{ parkingFine.id }}</span>
        </div>
        <div class="d-flex justify-space-between">
          <span class="font-weight-bold">
            {{ $vuetify.lang.t('$vuetify.ENFORCEMENT.REFERENCE_NUMBER') }}
          </span>
          <span>{{ parkingFine.referenceNumber }}</span>
        </div>
        <div class="d-flex justify-space-between">
          <span class="font-weight-bold">
            {{
              $vuetify.lang.t(
                '$vuetify.ENFORCEMENT.PARKING_FINE_PROFILE_BENEFICIARY'
              )
            }}
          </span>
          <span>{{ parkingFine.parkingFineProfileBeneficiary }}</span>
        </div>
        <div class="d-flex justify-space-between">
          <span class="font-weight-bold">
            {{ $vuetify.lang.t('$vuetify.STATUS') }}
          </span>
          <span>{{ parkingFine.status }}</span>
        </div>
        <div class="d-flex justify-space-between">
          <span class="font-weight-bold">
            {{ $vuetify.lang.t('$vuetify.ENFORCEMENT.CREATED_AT') }}
          </span>
          <span>{{ dateEE(parkingFine.createdAt) }}</span>
        </div>
        <div class="d-flex justify-space-between">
          <span class="font-weight-bold">
            {{ $vuetify.lang.t('$vuetify.ENFORCEMENT.OVERDUE') }}
          </span>
          <span>{{
            parkingFine.status === 'UNPAID'
              ? dayDiff(new Date(parkingFine.createdAt), new Date())
              : '-'
          }}</span>
        </div>
        <div class="d-flex justify-space-between">
          <span class="font-weight-bold">{{
            $vuetify.lang.t('$vuetify.ENFORCEMENT.FINE_PAYMENT_DATE')
          }}</span>
          <span>{{
            parkingFine.status === 'PAID' ? parkingFine.paymentDate : '-'
          }}</span>
        </div>
        <div class="d-flex justify-space-between">
          <span class="font-weight-bold">
            {{ $vuetify.lang.t('$vuetify.ENFORCEMENT.REASON') }}
          </span>
          <span>{{ parkingFine.reason }}</span>
        </div>
        <div class="d-flex justify-space-between">
          <span class="font-weight-bold">
            {{ $vuetify.lang.t('$vuetify.ENFORCEMENT.ADDITIONAL_REASON_CODE') }}
          </span>
          <span>{{
            parkingFine.additionalReasonCode
              ? parkingFine.additionalReasonCode
              : '-'
          }}</span>
        </div>
        <div class="d-flex justify-space-between">
          <span class="font-weight-bold">
            {{ $vuetify.lang.t('$vuetify.ENFORCEMENT.ADDITIONAL_REASON_TEXT') }}
          </span>
          <span>{{
            parkingFine.additionalReasonText
              ? parkingFine.additionalReasonText
              : '-'
          }}</span>
        </div>
        <div class="d-flex justify-space-between">
          <span class="font-weight-bold">
            {{ $vuetify.lang.t('$vuetify.COST') }}
          </span>
          <span>
            {{ (parkingFine.amountInCents / 100).toFixed(2) }}
            {{ parkingFine.currency }}
          </span>
        </div>
        <div class="d-flex justify-space-between">
          <span class="font-weight-bold">
            {{ $vuetify.lang.t('$vuetify.ENFORCEMENT.LAST_AMOUNT') }}
          </span>
          <span>
            {{ (parkingFine.lastAmountInCents / 100).toFixed(2) }}
            {{ parkingFine.currency }}
          </span>
        </div>
      </v-col>
      <v-col sm="4" class="text--primary">
        <div class="d-flex justify-space-between">
          <span class="font-weight-bold">
            {{ $vuetify.lang.t('$vuetify.CAR_NUMBER') }}
          </span>
          <span>{{ parkingFine.vehicleNumber }}</span>
        </div>
        <div class="d-flex justify-space-between">
          <span class="font-weight-bold">
            {{ $vuetify.lang.t('$vuetify.ENFORCEMENT.VEHICLE_NUMBER_COUNTRY') }}
          </span>
          <span>{{ parkingFine.vehicleNumberCountry }}</span>
        </div>
        <div class="d-flex justify-space-between">
          <span class="font-weight-bold">
            {{ $vuetify.lang.t('$vuetify.ENFORCEMENT.LOCATION') }}
          </span>
          <span>{{
            parkingFine.place &&
            parkingFine.place.name &&
            parkingFine.place.name !== ''
              ? parkingFine.place.name
              : '-'
          }}</span>
        </div>
        <div class="d-flex justify-space-between">
          <span class="font-weight-bold">
            {{ $vuetify.lang.t('$vuetify.ZONE') }}
          </span>
          <span>{{ parkingFine.place.zone }}</span>
        </div>
        <div v-if="isGlobalAdmin" class="d-flex justify-space-between">
          <span class="font-weight-bold">
            {{ $vuetify.lang.t('$vuetify.ENFORCEMENT.ISSUER_NAME') }}
          </span>
          <span>{{
            parkingFine.issuerName && parkingFine.issuerName !== ''
              ? parkingFine.issuerName
              : '-'
          }}</span>
        </div>
        <div class="d-flex justify-space-between">
          <span class="font-weight-bold">
            {{ $vuetify.lang.t('$vuetify.ENFORCEMENT.DEBTS_SENT') }}
          </span>
          <span>
            {{ parkingFine.debtsSent }}
            {{
              parkingFine.debtsSent === true
                ? `(${dateEE(parkingFine.debtsSentTime)})`
                : ''
            }}
          </span>
        </div>
        <div
          v-if="parkingFine.forwardDebtsAt && !parkingFine.doNotForwardDebts"
          class="d-flex justify-space-between"
        >
          <span class="font-weight-bold">
            {{
              $vuetify.lang.t('$vuetify.ENFORCEMENT.DEBTS_WILL_BE_FORWARDED_AT')
            }}
          </span>
          <span>
            {{ `(${dateEE(parkingFine.forwardDebtsAt)})` }}
          </span>
        </div>
      </v-col>
      <!-- <v-col sm="4" class="text--primary">
        <div class="font-weight-bold mb-2">
          {{ $vuetify.lang.t('$vuetify.ENFORCEMENT.COMMENTS') }}
        </div>
        <v-textarea
          :value="
            parkingFine.comments !== ''
              ? parkingFine.comments
              : $vuetify.lang.t('$vuetify.ENFORCEMENT.NO_COMMENTS')
          "
          :label="$vuetify.lang.t('$vuetify.ENFORCEMENT.COMMENTS')"
          hide-details
          solo
          readonly
        >
        </v-textarea>
      </v-col> -->
    </v-row>
    <parking-fine-images-dialog
      v-if="parkingFineImagesDialog"
      :visible="parkingFineImagesDialog"
      :parking-fine="parkingFine"
      @close="parkingFineImagesDialog = false"
    />
    <mark-parking-fine-as-paid-dialog
      v-if="markFineAsPaidDialog"
      :visible="markFineAsPaidDialog"
      :parking-fine="parkingFine"
      @close="markFineAsPaidDialog = false"
    />
    <cancel-parking-fine-dialog
      v-if="cancelFineDialog"
      :visible="cancelFineDialog"
      :parking-fine="parkingFine"
      @close="cancelFineDialog = false"
    />
    <edit-parking-fine-dialog
      v-if="editParkingFineDialog"
      :visible="editParkingFineDialog"
      :parking-fine="parkingFine"
      @close="editParkingFineDialog = false"
    />
    <debt-income-dialog
      v-if="debtIncomeDialog"
      :visible="debtIncomeDialog"
      :parking-fine="parkingFine"
      @close="debtIncomeDialog = false"
    />
  </div>
</template>

<script>
import formatDate from '@/mixins/formatDate'
import { mapActions, mapGetters, mapMutations } from 'vuex'

export default {
  name: 'ParkingFineDetails',
  components: {
    ParkingFineImagesDialog: () =>
      import(
        /* webpackChunkName: "ParkingFineImagesDialog" */ '@/components/enforcement/ParkingFineImagesDialog.vue'
      ),
    MarkParkingFineAsPaidDialog: () =>
      import(
        /* webpackChunkName: "MarkParkingFineAsPaidDialog" */ '@/components/enforcement/MarkParkingFineAsPaidDialog.vue'
      ),
    CancelParkingFineDialog: () =>
      import(
        /* webpackChunkName: "CancelParkingFineDialog" */ '@/components/enforcement/CancelParkingFineDialog.vue'
      ),
    EditParkingFineDialog: () =>
      import(
        /* webpackChunkName: "EditParkingFineDialog" */ '@/components/enforcement/EditParkingFineDialog.vue'
      ),
    DebtIncomeDialog: () =>
      import(
        /* webpackChunkName: "DebtIncomeDialog" */ '@/components/enforcement/DebtIncomeDialog.vue'
      )
  },
  mixins: [formatDate],
  props: {
    parkingFine: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      parkingFineImagesDialog: false,
      editParkingFineDialog: false,
      markFineAsPaidDialog: false,
      cancelFineDialog: false,
      debtIncomeDialog: false,
      forwardDebtsAtPicker: false
    }
  },
  computed: {
    ...mapGetters('authentication', ['isGlobalAdmin']),
    ...mapGetters('app', ['loading']),
    doNotForwardDebts: {
      get() {
        return this.parkingFine.doNotForwardDebts
      },
      set(value) {
        this.setSelectedParkingFineSpecificKeyValue({
          key: 'doNotForwardDebts',
          value
        })
      }
    },
    forwardDebtsAt: {
      get() {
        return this.parkingFine.forwardDebtsAt
      },
      set(value) {
        this.setSelectedParkingFineSpecificKeyValue({
          key: 'forwardDebtsAt',
          value
        })
      }
    }
  },
  methods: {
    ...mapActions('enforcement', [
      'sendParkingFineToJulianus',
      'resetParkingFine',
      'putDoNotForwardDebtsValue',
      'putForwardDebtsAtValue'
    ]),
    ...mapMutations('enforcement', ['setSelectedParkingFineSpecificKeyValue']),
    dayDiff(startdate, enddate) {
      // Set time to 0, to calculate the day difference by comparing year, month, and day values
      startdate.setHours(0, 0, 0, 0)
      enddate.setHours(0, 0, 0, 0)

      const timeDiff = enddate - startdate
      const dayCount = timeDiff / (1000 * 60 * 60 * 24)

      return Math.floor(dayCount)
    },
    openMarkFineAsPaidDialog() {
      this.markFineAsPaidDialog = true
    },
    openCancelFineDialog() {
      this.cancelFineDialog = true
    },
    openImageDialog() {
      this.parkingFineImagesDialog = true
    },
    openEditParkingFineDialog() {
      this.editParkingFineDialog = true
    },
    openDebtIncomeDialog() {
      this.debtIncomeDialog = true
    },
    sendToJulianus() {
      this.$confirm(this.$vuetify.lang.t('$vuetify.CAN_NOT_BE_UNDONE'), {
        title: this.$vuetify.lang.t('$vuetify.ARE_YOU_SURE'),
        color: 'error',
        icon: 'mdi-alert',
        persistent: true,
        buttonTrueText: this.$vuetify.lang.t('$vuetify.YES'),
        buttonFalseText: this.$vuetify.lang.t('$vuetify.CANCEL')
      }).then(async option => {
        if (option) {
          this.sendParkingFineToJulianus(this.parkingFine)
        }
      })
    },
    resetFine() {
      this.$confirm(this.$vuetify.lang.t('$vuetify.CAN_NOT_BE_UNDONE'), {
        title: this.$vuetify.lang.t('$vuetify.ARE_YOU_SURE'),
        color: 'error',
        icon: 'mdi-alert',
        persistent: true,
        buttonTrueText: this.$vuetify.lang.t('$vuetify.YES'),
        buttonFalseText: this.$vuetify.lang.t('$vuetify.CANCEL')
      }).then(async option => {
        if (option) {
          this.resetParkingFine(this.parkingFine)
        }
      })
    },
    onDoNotForwardDebtsChange(newValue) {
      this.putDoNotForwardDebtsValue({
        this: this,
        doNotForwardDebts: newValue,
        parkingFineId: this.parkingFine.id
      })
    },
    updateForwardDebtsAtValue() {
      this.$confirm(this.$vuetify.lang.t('$vuetify.CAN_NOT_BE_UNDONE'), {
        title: this.$vuetify.lang.t('$vuetify.ARE_YOU_SURE'),
        color: 'error',
        icon: 'mdi-alert',
        persistent: true,
        buttonTrueText: this.$vuetify.lang.t('$vuetify.YES'),
        buttonFalseText: this.$vuetify.lang.t('$vuetify.CANCEL')
      }).then(async option => {
        if (option) {
          this.putForwardDebtsAtValue({
            this: this,
            forwardDebtsAt: this.forwardDebtsAt,
            parkingFineId: this.parkingFine.id
          })
        } else {
          this.forwardDebtsAt = ''
        }
      })
    },
    copyToClipboard(value) {
      const tempTextarea = document.createElement('textarea')

      tempTextarea.value = value
      document.body.appendChild(tempTextarea)
      tempTextarea.select()

      try {
        navigator.clipboard.writeText(tempTextarea.value)
        this.$store.commit(
          'app/setSnackbar',
          {
            show: true,
            type: 'success',
            message: 'Link copied to clipboard'
          },
          { root: true }
        )
      } catch (err) {
        this.$store.commit(
          'app/setSnackbar',
          {
            show: true,
            type: 'error',
            message: 'Failed to copy link'
          },
          { root: true }
        )
      }

      document.body.removeChild(tempTextarea)
    }
  }
}
</script>
